const getQrCodeDownloadFileName = (title: string): string => `${title}-ShareCode.png`;

export default getQrCodeDownloadFileName;
